import _ from  'lodash';

/**
 * Logging
 * @param {string} type of console message
 * @param {string} content of console message
 */
const logging = (type, content) => {
    const sign = " - - - - - - - - - - - - - - - - - - - - - - ";
    const result = `${sign}${content}${sign}`;
    switch(type) {

        case "log":
            console.log(result);
            break;
        case "error":
            console.error(result);
            break;
        case "info":
            console.info(result);
            break;
        case "warn":
            console.warn(result);
            break;
        case "debug":
            console.debug(result);
            break;
        default:
            console.log(result);

}
};


/**
 * Maybe class to check val value (null, undefined, "")
 */
class Maybe {

    // constructor
    constructor(val) {
        this._value = val;
    }

    // isNothing method
    isNothing() {
        return (
            this._value === null || 
            this._value === undefined || 
            this._value === false || 
            this._value === 0 ||
            this._value === '-' ||
            this._value === '' ||
            this._value === {}
        
        );
    }

    // map method
    map(f) {
        if (this.isNothing()) {
            return Maybe.of(null);
        }
        return Maybe.of(f(this._value));
    }

    // join method
    join() {
        return this._value;
    }

    // chain method
    chain(f) {
        return this.map(f).join();
    }

    // orElse method
    orElse(defaultVal) {
        if (this.isNothing()) {
            return Maybe.of(defaultVal);
        }
        return this;
    }

    // defaultFun
    orElseFun(f) {
        if(this.isNothing()) {
            return f();
        }
        return this;
    }

}

/**
 * Maybe of function
 * @param val
 * @returns {Maybe class instance}
 */
Maybe.of = (val) => {
    return new Maybe(val);
};

/**
 * Export
 */
export {logging, Maybe};







// WEBPACK FOOTER //
// ./src/utils/logging.js